var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"btn blue darken-3",attrs:{"to":_vm.link}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])])
}
var staticRenderFns = []

export { render, staticRenderFns }